import { render, staticRenderFns } from "./DeliveryWindowQuery.vue?vue&type=template&id=825d5224&scoped=true"
import script from "./DeliveryWindowQuery.vue?vue&type=script&lang=js"
export * from "./DeliveryWindowQuery.vue?vue&type=script&lang=js"
import style0 from "./DeliveryWindowQuery.vue?vue&type=style&index=0&id=825d5224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825d5224",
  null
  
)

export default component.exports